import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet';
import SignupForm from './utils/SignupForm';
import { Link } from 'react-router-dom';
import HealthSection from './utils/HealthSection';

const GymWorkoutsForBuildingEndurance = () => {
    return (
        <div>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Maximize Endurance with Effective Gym Workouts</h1>
                    <h2>At Ramp Physio and Fitness in Homebush, NSW, we specialize in gym workouts that are designed to build endurance and stamina, helping you achieve your health and fitness goals with our expert guidance.</h2>
                    <p>Building endurance is not just about increasing the amount of time you can exercise; it's about enhancing your body's ability to perform intense activities over longer periods. In this comprehensive article, we'll explore various gym workouts and strategies that are essential for boosting your endurance and stamina. From high-intensity training to strength-building exercises, you'll discover the most effective methods to fortify your endurance for sports, daily activities, and overall health.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Strategies for Enhanced Stamina</h1>
                        <p>Endurance training is a multifaceted approach that requires a combination of different workout strategies. This includes interval training, which involves alternating between high-intensity bursts and active recovery periods, and tempo workouts that help your body adapt to sustained efforts. Additionally, incorporating strength training exercises is vital for building the muscle endurance needed to support long-duration activities.</p>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            </SkewedContainer>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Key Endurance-Building Exercises</h1>
                    <p>Here are 10 exercises that are crucial for building endurance:
                        <ul>
                            <li>Interval Sprints</li>
                            <li>Tempo Runs</li>
                            <li>Circuit Training</li>
                            <li>Plyometric Exercises</li>
                            <li>Swimming Laps</li>
                            <li>Rowing Machine Intervals</li>
                            <li>Kettlebell Workouts</li>
                            <li>Spin Bike Intervals</li>
                            <li>Stair Climbing</li>
                            <li>Long-Distance Cycling</li>
                        </ul>
                        These exercises, when combined with proper rest and nutrition, can significantly improve your muscular endurance and cardiovascular capacity.</p>
                </div>
            </div>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Understanding Muscular Endurance</h1>
                    <p>Muscular endurance refers to the ability of your muscles to perform repeated contractions over time without fatigue. This is crucial for activities such as long-distance running, cycling, and swimming. To improve muscular endurance, incorporating exercises like calisthenics, bodyweight movements, and using resistance bands are essential. These exercises help in enhancing the stamina of specific muscle groups and contribute to overall endurance.</p>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Personalized Endurance Training Plans</h1>
                    <p>At Ramp Physio and Fitness, we understand that everyone's fitness level and goals are unique. That's why we offer personalized training plans that cater to your individual needs. Our trainers will work with you to design a program that not only builds endurance but also takes into consideration your strengths, weaknesses, and personal objectives. Whether you're training for a marathon or simply looking to increase your energy levels, we're here to support you every step of the way.</p>
                    <br></br>
                    <p>
                        In conclusion, building endurance is a journey that requires patience, dedication, and the right set of exercises. With the guidance of Ramp Physio and Fitness, you can embark on this journey with confidence, knowing that you have a team of experts supporting your fitness aspirations. Join us today and unleash your potential with gym workouts that are specifically tailored to enhance your endurance and stamina.
                    </p>
                </div>
            </div>
            </SkewedContainer>
            
    <SubpagesLink />
    <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default GymWorkoutsForBuildingEndurance;